import { Button, Result } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { consumeReturnTo, exchangeCode, verifyState } from '../../auth/questionpro';
import useAuth from '../../auth/useAuth';
import Loading from '../../components/Loading';

// Lands here from QuestionPro after login: /callback?code=...&state=...
function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { completeLogin, loginWithRedirect } = useAuth();
  const [error, setError] = useState(null);

  // The authorization code is single-use on QuestionPro's side - a second
  // exchange fails. This latch keeps a re-render or a StrictMode double-effect
  // from burning the code.
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) {
      return;
    }
    exchanged.current = true;

    const code = searchParams.get('code');
    const returnedState = searchParams.get('state');
    const returnTo = consumeReturnTo();

    if (!code) {
      setError(searchParams.get('error_description') || 'QuestionPro did not return a login code.');
      return;
    }
    if (!verifyState(returnedState)) {
      setError('Login state did not match. Please try signing in again.');
      return;
    }

    exchangeCode(code)
      .then((token) => completeLogin(token))
      .then(() => navigate(returnTo, { replace: true }))
      .catch((err) => setError(err.message));
  }, [searchParams, completeLogin, navigate]);

  if (error) {
    return (
      <Result
        status="error"
        title="Could not sign you in"
        subTitle={error}
        extra={
          <Button type="primary" onClick={() => loginWithRedirect()}>
            Try again
          </Button>
        }
      />
    );
  }

  return <Loading />;
}

export default AuthCallback;
